import { Event } from "../classes/Event";
import { utils } from "../../../../../shop/frontend/web/js/utils";

/**
 *  Класс для страницы мероприятия
 * @extends Event
 */
window.currentViewId = 0;

export class EventPage extends Event {
	constructor() {
		super();
		this.$currentCount = $(".js-count-event");
		this.$svg = $("#js-svg");
		this.unit_id = this.$svg.data("unit");
		this.$svgElement = this.$svg.find("svg");
		this.$elements = this.$svgElement.find("g[mode]");
		this.$placeToSvg = $("#js-change-svg");
		this.$order = $(".js-order");
		this.eventId = this.$order.data("event");
		this.$buy = $("#js-order-button");
		this.$places = $("#js-places");
		this.$placesLegend = $("#js-places-legend");
		this.$placesCheckPrice = $("#js-places-check-price");
		this.$placesChoose = $("#js-places-choose");
		this.$placesInfo = $("#js-places-info");
		this.$placesChange = $("#js-places-change");
		this.$placesCost = $("#js-places-cost");
		this.$orderInfo = $("#js-order-info");
		this.$placesLimit = $("#js-places-limit");
		this.$placesBack = $("#js-places-back");
		this.$planZoomIn = $("#js-plan-zoom-in");
		this.$planZoomOut = $("#js-plan-zoom-out");
		this.$planZoomReset = $("#js-plan-zoom-reset");
		this.$tooltip = $("#js-tooltip-info");
		this.$prices = $(".js-places-prices");
		this.$popupModal = $("#js-popup-modal");
		this.$tickets = $("#js-tickets");
		this.$ticketsItems = $("#js-tickets-items");
		this.$stadium = $("#js-stadium");
		this.$stadiumPlan = this.$stadium.find(".threesixty");
		this.$stadiumPlace = $("#js-stadium-place");
		this.$mobileBuy = $(".js-mobile-buy");
		this.$bottom = $("#js-bottom");
		this.$eventSum = $("#js-event-sum");
		this.stadiumWidth = null;
		this.stadiumHeight = null;
		this.reverse = null;
		this.prices = window.prices;
		this.uniquePrices = window.uniquePrices;
		this.has_stadium_panorama = this.$stadium.length > 0;
		this.languages = window.languages;
		this.$countEvent = $("#js-count-event");
		super.initFrontend();
	}

	init() {
		this.setIsSectorPlan();
		if (this.isDesktop.matches) {
			this.setSvgPlan();
			this.initTooltip();
		}
		this.setUpListenersCurrent();
		this.addActionToBack();

		if (this.isSectorPlan) {
			this.setTags();

			this.addActionToSector();
			this.getLanguages().then(() => {
				if (this.isDesktop.matches) {
					this.getZones().then(res => {
						this.setZones(this.updateZones(res));
						this.addActionToPricesLabelToSector();
					});
				}
			});
			this.$placesLegend.show();
			this.$placesChoose.hide();
			this.$places.addClass("active");
			if (this.has_stadium_panorama) {
				this.initStadium();
				this.addStadium();
			}
			this.setSectorsToStorage(); //загружает в хранилище минимальные по цене сектора
		} else {
			this.$stadium.attr("hidden", "true");
			this.$placesInfo.removeClass("places__info_sector");
			if (this.isDesktop.matches) {
				this.setColors().then(() => {
					this.setPricesLabelToPlace();
					this.addActionToPricesLabelToPlace();
				});
			}
		}
		this.addSliderToDates();
		this.backInHistory();
		$(".body").addClass("ready-for-test");
	}

	setUpListenersCurrent() {
		$(document).on("click", ".js-places-open", e => {
			const element = $(e.currentTarget);
			element.toggleClass("active");
			$(".js-tickets").slideToggle("slow");
		});

		if (window.location.pathname.includes("event") && !this.isDesktop.matches) {
			this.getPopup();
		}

		this.$mobileBuy.on("click", () => {
			if (!this.isDesktop.matches) {
				this.getPopup();
			}
		});

		$(document).on("click", ".custom_previous", () => {
			if (this.reverse === "right") {
				this.stadium.previous();
			} else {
				this.stadium.next();
			}
		});

		$(document).on("click", ".custom_next", () => {
			if (this.reverse === "right") {
				this.stadium.next();
			} else {
				this.stadium.previous();
			}
		});

		$(document).on("click", "#js-stadium-prev", () => {
			if (this.reverse === "right") {
				this.stadium.previous();
			} else {
				this.stadium.next();
			}
		});

		$(document).on("click", "#js-stadium-next", () => {
			if (this.reverse === "right") {
				this.stadium.next();
			} else {
				this.stadium.previous();
			}
		});
	}

	setSectorsToStorage() {
		//set min price sectors to storage
		const sorted = this.prices.sort((a, b) => a.price - b.price);

		for (let i = 0; i < sorted.length; i++) {
			const minPrice = sorted[0].price;
			if (sorted[i].price === minPrice) {
				const viewId = sorted[i].viewId;
				this.storage.getItem(`${this.unit_id}_${viewId}`).then(res => {
					if (!res) {
						this.getSvgPrices(this.eventId, viewId, true).then(res => {
							try {
								this.storage
									.setItem(`${this.unit_id}_${viewId}`, {
										...res,
										time: +new Date(),
									})
									.then(() => {
										this.overlay.hide();
									});
							} catch (e) {}
						});
					}
				});
			}
		}
	}

	setAddToCart(sid) {
		this.addToCart(sid).then(res => {
			if (res.error) {
				alert(res.msg);
			}
			if (res.carts) {
				if (ym && res.isNew) ym(window.ymtracker, "reachGoal", "addToCart");
				const place = $(`#${sid}`);
				place.data("available", "false");
				this.updateActiveSeat(sid, true);
				const parentElement = $(`.js-order[data-event="${this.eventId}"]`);
				const promo = parentElement.find(".js-promo");
				if (res.carts) {
					this.setTicketsItems(res.carts);
				}
				$(".order.order_event").removeClass("sector-plan").addClass("active");
				this.$currentCount.text(Number(this.$currentCount.text()) + 1);
				this.$eventSum.text(Number(this.$eventSum.text()) + res.carts[0].price);
				this.$orderInfo.show();
				promo.show();
				if (this.isDesktop.matches) {
					this.$placesLimit.show();
				}
				this.$placesChange.addClass("short");
				this.$order.removeClass("short");
				this.$placesCost.addClass("show");
				let count = 0;
				$.each(res.order.carts, (index, elem) => {
					if (elem.event_id === this.eventId) {
						count++;
					}
				});
				this.$countEvent.text(count);
				this.$countWord.text(
					utils.wordEnding(count, [
						this.getWord("event", "ticket"),
						this.getWord("event", "tickets"),
						this.getWord("event", "tickets "),
					])
				);
				this.$bottom.addClass("active");
				const code = promo.data("promocode");

				if (code) {
					this.setPromocode(this.eventId, code);
				}

				if (!this.$buy.data("payment")) {
					this.$buy.data("payment", res.order.id);
					let type = "service";
					if (res.order.type_id === 0) {
						type = "event";
					}
					this.$buy.data("order-id", res.order.id);
					this.$buy.attr("href", `/pay/pay?id=${res.order.id}`);
					this.$buy.data("type", type);
				}
				this.setPlaceToStorage(sid, place);
				//При добавлении в корзину очищает план, цены данного сектора из хранилища
				this.storage.removeItem(`${this.unit_id}_${window.currentViewId}`);
			}
			if (res.redraw) {
				this.storage.removeItem(`${this.unit_id}_` + window.currentViewId);
				$(`#${sid}`).addClass("in-cart");
				window.location.reload();
			}

			if (res.limit) {
				alert("Вы превысили максимально допустимое количество мест для брони");
			} else {
				for (let i = 0; i < res.carts.length; i++) {
					const item = res.carts[i];
					const isPack = res.carts[i].is_pack;
					if (!isPack) {
						$(`#${item.sid}`).addClass("in-cart");
					}
				}
				this.getCartCount(this.eventId);
			}
		});
	}

	initStadium() {
		let needStadium = true;
		let itFirst = true;
		let path;
		$(document).on("mouseover", e => {
			if (this.hasZoom) return;
			const element = $(e.target);
			if (element.closest("#svg").length || element.closest(".stadium").length) {
				if (this.isDesktop.matches) {
					const activeSector = $(element).closest("g[view_id]");
					if (activeSector.length) {
						let dataPath = activeSector.attr("path");
						if (itFirst) {
							this.initTreeSixty(dataPath);
							itFirst = false;
							path = dataPath;
						} else {
							if (dataPath === path) {
								needStadium = false;
							} else {
								needStadium = true;
								path = dataPath;
							}

							if (needStadium) {
								this.initTreeSixty(path);
							}
						}
						this.$stadium.addClass("active");
					}
				}
			} else {
				this.$stadium.removeClass("active");
			}
		});
	}

	initTreeSixty(path) {
		this.stadium = null;
		this.reverse = path;
		this.$stadiumPlan.stop();
		this.stadium = this.$stadiumPlan.ThreeSixty({
			totalFrames: 32, // Общее число кадров
			endFrame: 32, // конечный кадр
			currentFrame: 13, // с какого кадра стартовать
			imgList: ".threesixty_images", // селектор изображений
			progress: ".threesixty__spinner", // селектор элемента процесса загрузки
			imagePath: `/images/stadium/${path}/`, // путь к папке с изображениями
			filePrefix: "", // префикс файлов
			ext: ".jpg", // формат изображения
			height: this.stadiumHeight,
			width: this.stadiumWidth,
			navigation: false,
		});
	}

	addSliderToDates() {
		if (this.isDesktop.matches) {
			const datesSliderDom = document.querySelector("#js-swiper-dates");
			if (!datesSliderDom) {
				return false;
			}
			new Swiper(datesSliderDom, {
				navigation: {
					nextEl: datesSliderDom.parentNode.querySelector(".swiper-button-next"),
					prevEl: datesSliderDom.parentNode.querySelector(".swiper-button-prev"),
				},
				breakpoints: {
					768: {
						slidesPerView: 4,
					},
					880: {
						slidesPerView: 5,
					},
					1024: {
						slidesPerView: 6,
					},
				},
			});
		}
	}

	backInHistory() {
		$("#js-back").on("click", e => {
			e.preventDefault();
			history.back();
		});
	}
}

const event = new EventPage();
event.init();
